const resetValues = {
  validViewed: undefined,
  validDate: undefined,
  // validTypeApp: undefined,
  validContentType: undefined,
  validTitle: undefined,
  viewed: undefined,
  date: undefined,
  // typeApp: undefined,
  contentType: undefined,
  title: undefined
};
const initialValues = {
  ...resetValues,
  validForm: false
};

const viewsSelector = [
  {
    value: false,
    text: 'No leídos'
  },
  {
    value: true,
    text: 'Leídos'
  }
];

const contentTypeSelector = [
  {
    value: 'NEWS',
    text: 'Noticias'
  },
  {
    value: 'EVENT',
    text: 'Eventos'
  },
  {
    value: 'PRESSRESUME',
    text: 'Resumen de Prensa'
  }

  // {
  // value: 'DRAW',
  // text: 'Sorteo'
  // },
  // {
  // value: 'CMS',
  // text: 'Generales'
  // },
  // {
  // value: 'RELEASE',
  // text: 'Comunicado'
  // },
  // {
  // value: 'PARCEL',
  // text: 'Paquetería'
  // }
];

export { resetValues, initialValues, viewsSelector, contentTypeSelector };
